import { Observable } from '@common/nav';
import { INamed, fn } from '@common/utils';

/** ToggleButton directive */
export const ToggleButtonDirective = [function ToggleButtonDirective(): ng.IDirective {
    return {
        restrict: "E",
        scope: {
            defaulttitle: "=",
            titlechecked: "=",
            symbolicon: "=",
            symboliconchecked: "=",
            checked: "=",
            disabled: '=',
            hidechecked: "=",
            defaulttooltip: "=",
            tooltipchecked: "="
        },
        link: ($scope: any) => {
            $scope.idms_toggle = () => {
                if(!$scope.disabled === true) {
                    $scope.checked = !$scope.checked;
                }
            };
        },
        template: require('./ToggleButton.fragment.html')
    };
}];

export interface IMainMenuItem {

    IsSelected: boolean;

    readonly Warning: {
        IsError: boolean;
        Message: string;
    };
}

/** Main menu item - part of a main menu */
export class MainMenuItem {
    ID: string;
    IsSelected: boolean;
    Menu: MainMenu;
    readonly Warning: {
        IsError: boolean;
        Message: string;
    };
}

/** Main menu that controls the content view */
export class MainMenu extends Observable {
    constructor() {
        super();
        this.MainMenuItems = {};
    }

    MainMenuItems: INamed<MainMenuItem>;
    /** Currently Selected Item */
    SelectedItem: MainMenuItem;
    /** Currently selected Item's Id */
    SelectedID: string;
    /** Touched Items : Item has been selected at least once (used for lazy loading)  */
    TouchedItems: INamed<MainMenuItem> = {};
    Expanded = false;

    /** Add Menu Item */
    AddItem(id: string, template?: Partial<IMainMenuItem> ) {
        var result = <MainMenuItem>$.extend(new MainMenuItem(), template || {});
        result.ID = id;
        result.Menu = this;
        this.MainMenuItems[id] = result;
        return result;
    }
    /** select item */
    SelectItem(item: string | MainMenuItem) {
        if (typeof item == "string")
            item = this.MainMenuItems[<any>item];

        var me = this;

        if (item instanceof MainMenuItem) {
            var mnuItem = item;
            fn.DictToArray(this.MainMenuItems).forEach(value => {
                var isselected = value === mnuItem;
                value.IsSelected = isselected;

                // Update selected menu item
                if (isselected) {
                    me.SelectedItem = mnuItem;
                    me.TouchedItems[mnuItem.ID] = mnuItem;
                    me.SelectedID = mnuItem.ID;
                    this.trigger("ItemSelected", { Item: mnuItem });

                }
            });
            return mnuItem;
        }
    }
}

/** Main menu item directive */
export const MainMenuItemDirective = [function MainMenuItemDirective(): ng.IDirective {
    return {
        restrict: "EA",
        scope: {
            itemmodel: "=",
            mnutitle: "=",
            mnucount: "=",
            mnuicon: "=",
            mnutooltip: '='
        },
        link: ($scope: ng.IScope, instanceElement: ng.IAugmentedJQuery,
            instanceAttributes: ng.IAttributes) => {
            // TODO : FixuP Refreence ???
            var mainMenuProp = fn.FindFirst(Object.getOwnPropertyNames($scope.$parent), propName => $scope.$parent[propName] instanceof MainMenu);

            if (mainMenuProp) {
                var onSelect = () => {
                    var mnuItem = <MainMenu>$scope.$parent[mainMenuProp],
                        mnuModel = <MainMenuItem>$scope["itemmodel"];
                    if (mnuItem) {
                        if (mnuItem.SelectedItem != mnuModel)
                            mnuItem.SelectItem(mnuModel);
                        else
                            mnuItem.trigger("ResetSelectedItem");
                    }
                    $scope.$apply();
                };
                instanceElement.bind('click', onSelect);
                $scope.$on("$destroy", () => {
                    instanceElement.unbind('click', onSelect);
                    $scope["itemmodel"] = null;
                });
                // Allow Reaction on Change
                var onmnuItemChange = () => $scope.$emit("MainMenuItemChanged");
                $scope.$watch("mnucount", onmnuItemChange);
                onmnuItemChange();
            }
        },
        template: require('./MainMenuItem.fragment.html')
    };
}];
